export const footerLayoutComponents = [
    {
        name: "Simple Column Footer",
        key: "simple-column",
        media: `
<footer class="py-6 px-4 border border-blue-500" style="zoom: 0.1;">
    <div class="flex justify-between p-4 border border-blue-500">
        <div class="column min-w-[192px] min-h-[160px] border border-blue-500">
            <div class="logo min-w-[48px] min-h-[32px] mb-4 border border-blue-500"></div>
            <div class="text-block min-h-[96px] border border-blue-500"></div>
        </div>
        <div class="column min-w-[192px] min-h-[160px] border border-blue-500">
            <div class="title min-w-[64px] min-h-[24px] mb-4 border border-blue-500"></div>
            <div class="links min-h-[96px] border border-blue-500"></div>
        </div>
        <div class="column min-w-[192px] min-h-[160px] border border-blue-500">
            <div class="title min-w-[64px] min-h-[24px] mb-4 border border-blue-500"></div>
            <div class="links min-h-[96px] border border-blue-500"></div>
        </div>
    </div>
</footer>
    `,
        content: `
<footer class="py-6 px-4">
    <div class="flex justify-between p-4">
        <div class="column min-w-[192px] min-h-[160px]">
            <div class="logo min-w-[48px] min-h-[32px] mb-4"></div>
            <div class="text-block min-h-[96px]"></div>
        </div>
        <div class="column min-w-[192px] min-h-[160px]">
            <div class="title min-w-[64px] min-h-[24px] mb-4"></div>
            <div class="links min-h-[96px]"></div>
        </div>
        <div class="column min-w-[192px] min-h-[160px]">
            <div class="title min-w-[64px] min-h-[24px] mb-4"></div>
            <div class="links min-h-[96px]"></div>
        </div>
    </div>
</footer>
    `,
    },
    {
        name: "Centered Content Footer",
        key: "centered-content",
        media: `
<footer class="py-6 px-4 border border-blue-500" style="zoom: 0.1;">
    <div class="min-w-4xl mx-auto text-center border border-blue-500 p-4">
        <div class="logo min-w-[48px] min-h-[32px] mx-auto mb-4 border border-blue-500"></div>
        <div class="text-block min-w-[24px]4 min-h-[24px] mx-auto mb-4 border border-blue-500"></div>
        <div class="social-icons flex justify-center gap-4 border border-blue-500 p-2">
            <div class="icon min-w-[24px] min-h-[24px] rounded-full border border-blue-500"></div>
            <div class="icon min-w-[24px] min-h-[24px] rounded-full border border-blue-500"></div>
            <div class="icon min-w-[24px] min-h-[24px] rounded-full border border-blue-500"></div>
        </div>
    </div>
</footer>
    `,
        content: `
<footer class="py-6 px-4">
    <div class="min-w-4xl mx-auto text-center p-4">
        <div class="logo min-w-[48px] min-h-[32px] mx-auto mb-4"></div>
        <div class="text-block min-w-[24px]4 min-h-[24px] mx-auto mb-4"></div>
        <div class="social-icons flex justify-center gap-4 p-2">
            <div class="icon min-w-[24px] min-h-[24px] rounded-full"></div>
            <div class="icon min-w-[24px] min-h-[24px] rounded-full"></div>
            <div class="icon min-w-[24px] min-h-[24px] rounded-full"></div>
        </div>
    </div>
</footer>
    `,
    },
    {
        name: "Newsletter Footer",
        key: "newsletter",
        media: `
<footer class="py-6 px-4 border border-blue-500" style="zoom: 0.1;">
    <div class="grid grid-cols-2 gap-8 p-4 border border-blue-500">
        <div class="column border border-blue-500 p-4">
            <div class="title min-w-[96px] min-h-[24px] mb-4 border border-blue-500"></div>
            <div class="text-block min-h-[64px] mb-4 border border-blue-500"></div>
            <div class="newsletter-form min-h-[40px] border border-blue-500"></div>
        </div>
        <div class="grid grid-cols-3 gap-4 border border-blue-500 p-4">
            <div class="links-column border border-blue-500">
                <div class="title min-w-[64px] min-h-[24px] mb-2 border border-blue-500"></div>
                <div class="links space-y-2 border border-blue-500"></div>
            </div>
            <div class="links-column border border-blue-500">
                <div class="title min-w-[64px] min-h-[24px] mb-2 border border-blue-500"></div>
                <div class="links space-y-2 border border-blue-500"></div>
            </div>
            <div class="links-column border border-blue-500">
                <div class="title min-w-[64px] min-h-[24px] mb-2 border border-blue-500"></div>
                <div class="links space-y-2 border border-blue-500"></div>
            </div>
        </div>
    </div>
</footer>
    `,
        content: `
<footer class="py-6 px-4">
    <div class="grid grid-cols-2 gap-8 p-4">
        <div class="column p-4">
            <div class="title min-w-[96px] min-h-[24px] mb-4"></div>
            <div class="text-block min-h-[64px] mb-4"></div>
            <div class="newsletter-form min-h-[40px]"></div>
        </div>
        <div class="grid grid-cols-3 gap-4 p-4">
            <div class="links-column">
                <div class="title min-w-[64px] min-h-[24px] mb-2"></div>
                <div class="links space-y-2"></div>
            </div>
            <div class="links-column">
                <div class="title min-w-[64px] min-h-[24px] mb-2"></div>
                <div class="links space-y-2"></div>
            </div>
            <div class="links-column">
                <div class="title min-w-[64px] min-h-[24px] mb-2"></div>
                <div class="links space-y-2"></div>
            </div>
        </div>
    </div>
</footer>
    `,
    },
    // Additional footer layouts continue below...
    {
        name: "Social Media Focused",
        key: "social-media",
        media: `
<footer class="py-6 px-4 border border-blue-500" style="zoom: 0.1;">
    <div class="flex flex-col items-center p-4 border border-blue-500">
        <div class="logo min-w-[48px] min-h-[32px] mb-4 border border-blue-500"></div>
        <div class="social-icons flex gap-6 mb-6 border border-blue-500 p-2">
            <div class="icon min-w-[32px] min-h-[32px] rounded-full border border-blue-500"></div>
            <div class="icon min-w-[32px] min-h-[32px] rounded-full border border-blue-500"></div>
            <div class="icon min-w-[32px] min-h-[32px] rounded-full border border-blue-500"></div>
        </div>
        <div class="legal-text min-w-[24px]4 min-h-[24px] border border-blue-500"></div>
    </div>
</footer>
    `,
        content: `
<footer class="py-6 px-4">
    <div class="flex flex-col items-center p-4">
        <div class="logo min-w-[48px] min-h-[32px] mb-4"></div>
        <div class="social-icons flex gap-6 mb-6 p-2">
            <div class="icon min-w-[32px] min-h-[32px] rounded-full"></div>
            <div class="icon min-w-[32px] min-h-[32px] rounded-full"></div>
            <div class="icon min-w-[32px] min-h-[32px] rounded-full"></div>
        </div>
        <div class="legal-text min-w-[24px]4 min-h-[24px]"></div>
    </div>
</footer>
    `,
    },
    {
        name: "Multi-Row Footer",
        key: "multi-row",
        media: `
<footer class="py-6 px-4 border border-blue-500" style="zoom: 0.1;">
    <div class="space-y-6 p-4 border border-blue-500">
        <div class="top-row flex justify-between border border-blue-500 p-2">
            <div class="logo min-w-[48px] min-h-[32px] border border-blue-500"></div>
            <div class="nav-links flex gap-4 border border-blue-500 p-2">
                <div class="link min-w-[48px] min-h-[24px] border border-blue-500"></div>
                <div class="link min-w-[48px] min-h-[24px] border border-blue-500"></div>
                <div class="link min-w-[48px] min-h-[24px] border border-blue-500"></div>
            </div>
        </div>
        <div class="divider h-px bg-gray-200 border border-blue-500"></div>
        <div class="bottom-row text-center border border-blue-500 p-2">
            <div class="copyright min-w-[192px] min-h-[24px] mx-auto border border-blue-500"></div>
        </div>
    </div>
</footer>
    `,
        content: `
<footer class="py-6 px-4">
    <div class="space-y-6 p-4">
        <div class="top-row flex justify-between p-2">
            <div class="logo min-w-[48px] min-h-[32px]"></div>
            <div class="nav-links flex gap-4 p-2">
                <div class="link min-w-[48px] min-h-[24px]"></div>
                <div class="link min-w-[48px] min-h-[24px]"></div>
                <div class="link min-w-[48px] min-h-[24px]"></div>
            </div>
        </div>
        <div class="divider h-px bg-gray-200"></div>
        <div class="bottom-row text-center p-2">
            <div class="copyright min-w-[192px] min-h-[24px] mx-auto"></div>
        </div>
    </div>
</footer>
    `,
    },
    {
        name: "Logo Grid Footer",
        key: "logo-grid",
        media: `
<footer class="py-6 px-4 border border-blue-500" style="zoom: 0.1;">
    <div class="flex flex-col items-center p-4 border border-blue-500">
        <div class="text-block min-w-[24px]4 min-h-[24px] mb-6 border border-blue-500"></div>
        <div class="logo-grid grid grid-cols-4 gap-4 mb-6 border border-blue-500 p-2">
            <div class="logo min-w-[48px] min-h-[32px] border border-blue-500"></div>
            <div class="logo min-w-[48px] min-h-[32px] border border-blue-500"></div>
            <div class="logo min-w-[48px] min-h-[32px] border border-blue-500"></div>
            <div class="logo min-w-[48px] min-h-[32px] border border-blue-500"></div>
        </div>
        <div class="legal-text min-w-[24px]4 min-h-[24px] border border-blue-500"></div>
    </div>
</footer>
    `,
        content: `
<footer class="py-6 px-4">
    <div class="flex flex-col items-center p-4">
        <div class="text-block min-w-[24px]4 min-h-[24px] mb-6"></div>
        <div class="logo-grid grid grid-cols-4 gap-4 mb-6 p-2">
            <div class="logo min-w-[48px] min-h-[32px]"></div>
            <div class="logo min-w-[48px] min-h-[32px]"></div>
            <div class="logo min-w-[48px] min-h-[32px]"></div>
            <div class="logo min-w-[48px] min-h-[32px]"></div>
        </div>
        <div class="legal-text min-w-[24px]4 min-h-[24px]"></div>
    </div>
</footer>
    `,
    },
    {
        name: "Split Section Footer",
        key: "split-section",
        media: `
<footer class="py-6 px-4 border border-blue-500" style="zoom: 0.1;">
    <div class="grid grid-cols-2 gap-8 p-4 border border-blue-500">
        <div class="contact-info border border-blue-500 p-4">
            <div class="title min-w-[64px] min-h-[24px] mb-4 border border-blue-500"></div>
            <div class="info-block min-h-[96px] border border-blue-500"></div>
        </div>
        <div class="quick-links border border-blue-500 p-4">
            <div class="title min-w-[64px] min-h-[24px] mb-4 border border-blue-500"></div>
            <div class="links-grid grid grid-cols-2 gap-4 border border-blue-500">
                <div class="link min-w-[96px] min-h-[24px] border border-blue-500"></div>
                <div class="link min-w-[96px] min-h-[24px] border border-blue-500"></div>
                <div class="link min-w-[96px] min-h-[24px] border border-blue-500"></div>
                <div class="link min-w-[96px] min-h-[24px] border border-blue-500"></div>
            </div>
        </div>
    </div>
</footer>
    `,
        content: `
<footer class="py-6 px-4">
    <div class="grid grid-cols-2 gap-8 p-4">
        <div class="contact-info p-4">
            <div class="title min-w-[64px] min-h-[24px] mb-4"></div>
            <div class="info-block min-h-[96px]"></div>
        </div>
        <div class="quick-links p-4">
            <div class="title min-w-[64px] min-h-[24px] mb-4"></div>
            <div class="links-grid grid grid-cols-2 gap-4">
                <div class="link min-w-[96px] min-h-[24px]"></div>
                <div class="link min-w-[96px] min-h-[24px]"></div>
                <div class="link min-w-[96px] min-h-[24px]"></div>
                <div class="link min-w-[96px] min-h-[24px]"></div>
            </div>
        </div>
    </div>
</footer>
    `,
    },
    {
        name: "Legal Minimal Footer",
        key: "legal-minimal",
        media: `
<footer class="py-6 px-4 border border-blue-500" style="zoom: 0.1;">
    <div class="flex flex-col items-center p-4 border border-blue-500">
        <div class="logo min-w-[48px] min-h-[32px] mb-4 border border-blue-500"></div>
        <div class="legal-links flex gap-4 mb-4 border border-blue-500 p-2">
            <div class="link min-w-[64px] min-h-[24px] border border-blue-500"></div>
            <div class="link min-w-[64px] min-h-[24px] border border-blue-500"></div>
            <div class="link min-w-[64px] min-h-[24px] border border-blue-500"></div>
        </div>
        <div class="copyright min-w-[192px] min-h-[24px] border border-blue-500"></div>
    </div>
</footer>
    `,
        content: `
<footer class="py-6 px-4">
    <div class="flex flex-col items-center p-4">
        <div class="logo min-w-[48px] min-h-[32px] mb-4"></div>
        <div class="legal-links flex gap-4 mb-4 p-2">
            <div class="link min-w-[64px] min-h-[24px]"></div>
            <div class="link min-w-[64px] min-h-[24px]"></div>
            <div class="link min-w-[64px] min-h-[24px]"></div>
        </div>
        <div class="copyright min-w-[192px] min-h-[24px]"></div>
    </div>
</footer>
    `,
    },
];

export const footerBuilderComponents = [
    // {
    //     name: "Footer Links",
    //     key: "footer-links",
    //     media: `
    //         <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" fill="none"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill="#000000" fill-rule="evenodd" d="M18 5a1 1 0 100-2H2a1 1 0 000 2h16zm-8 4a1 1 0 100-2H2a1 1 0 100 2h8zm9 3a1 1 0 01-1 1H2a1 1 0 110-2h16a1 1 0 011 1zm-9 5a1 1 0 100-2H2a1 1 0 100 2h8z"></path> </g></svg>
    //     `,
    //     content: `
    //         <div
    //             class="flex flex-col items-center max-lg:justify-center min-[500px]:items-start min-[500px]:flex-row gap-8">
    //             <div class="block">
    //                 <h4
    //                     class="text-lg text-gray-900 font-medium mb-4 min-[500px]:mb-7 text-center min-[500px]:text-left">Title</h4>
    //                 <ul class="grid gap-4 min-[500px]:gap-6 text-center min-[500px]:text-left">
    //                     <li><a class="inline-block w-full text-gray-600 hover:text-gray-900">Link 1</a></li>
    //                     <li><a class="inline-block w-full text-gray-600 hover:text-gray-900">Link 2</a></li>
    //                     <li><a class="inline-block w-full text-gray-600 hover:text-gray-900">Link 3</a></li>
    //                 </ul>
    //             </div>
    //         </div>
    //     `,
    // },
    {
        name: "Logo Section",
        key: "logo-section",
        media: `
    <div class="logo-section border border-blue-500 p-4" style="zoom: 0.1;">
      <div class="logo min-w-32 min-h-10 border border-blue-500"></div>
    </div>
        `,
        content: `
    <div class="logo-section p-4">
      <img src="/logo.svg" alt="Logo" class="logo min-w-32 min-h-10">
    </div>
        `,
    },
    {
        name: "Navigation Column",
        key: "nav-column",
        media: `
    <div class="nav-column border border-blue-500 p-4 min-w-48" style="zoom: 0.1;">
      <div class="title min-w-24 min-h-6 mb-4 border border-blue-500"></div>
      <div class="space-y-2">
        <div class="link min-w-32 min-h-5 border border-blue-500"></div>
        <div class="link min-w-32 min-h-5 border border-blue-500"></div>
        <div class="link min-w-32 min-h-5 border border-blue-500"></div>
      </div>
    </div>
        `,
        content: `
    <div class="nav-column p-4 min-w-48">
      <h4 class="title text-lg font-medium mb-4">Quick Links</h4>
      <ul class="space-y-2">
        <li><a href="#" class="link text-gray-600 hover:text-blue-500">About Us</a></li>
        <li><a href="#" class="link text-gray-600 hover:text-blue-500">Services</a></li>
        <li><a href="#" class="link text-gray-600 hover:text-blue-500">Contact</a></li>
      </ul>
    </div>
        `,
    },
    {
        name: "Newsletter Form",
        key: "newsletter-form",
        media: `
    <div class="newsletter-section border border-blue-500 p-4 min-w-96" style="zoom: 0.1;">
      <div class="title min-w-32 min-h-6 mb-4 border border-blue-500"></div>
      <div class="flex gap-2">
        <div class="input-field flex-1 min-h-10 border border-blue-500"></div>
        <div class="button min-w-20 min-h-10 border border-blue-500"></div>
      </div>
    </div>
        `,
        content: `
    <div class="newsletter-section p-4 min-w-96">
      <h4 class="title text-lg font-medium mb-4">Subscribe to our newsletter</h4>
      <form class="flex gap-2">
        <input type="email" placeholder="Enter your email" class="input-field flex-1 px-4 py-2 border rounded-lg">
        <button class="button px-6 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600">
          Subscribe
        </button>
      </form>
    </div>
        `,
    },
    {
        name: "Social Media Block",
        key: "social-media",
        media: `
    <div class="social-section border border-blue-500 p-4" style="zoom: 0.1;">
      <div class="title min-w-32 min-h-6 mb-4 border border-blue-500"></div>
      <div class="flex gap-4">
        <div class="social-icon min-w-8 min-h-8 rounded-full border border-blue-500"></div>
        <div class="social-icon min-w-8 min-h-8 rounded-full border border-blue-500"></div>
        <div class="social-icon min-w-8 min-h-8 rounded-full border border-blue-500"></div>
      </div>
    </div>
        `,
        content: `
    <div class="social-section p-4">
      <h4 class="title text-lg font-medium mb-4">Follow Us</h4>
      <div class="flex gap-4">
        <a href="#" class="social-icon min-w-8 min-h-8 bg-gray-200 rounded-full flex items-center justify-center hover:bg-blue-500">
          <svg class="min-w-4 min-h-4">...</svg>
        </a>
        <!-- Repeat for other social icons -->
      </div>
    </div>
        `,
    },
    {
        name: "Contact Info",
        key: "contact-info",
        media: `
    <div class="contact-section border border-blue-500 p-4 min-w-64" style="zoom: 0.1;">
      <div class="title min-w-32 min-h-6 mb-4 border border-blue-500"></div>
      <div class="space-y-2">
        <div class="info-line min-w-full min-h-5 border border-blue-500"></div>
        <div class="info-line min-w-full min-h-5 border border-blue-500"></div>
        <div class="info-line min-w-full min-h-5 border border-blue-500"></div>
      </div>
    </div>
        `,
        content: `
    <div class="contact-section p-4 min-w-64">
      <h4 class="title text-lg font-medium mb-4">Contact Us</h4>
      <div class="space-y-2">
        <p class="info-line text-gray-600">123 Business Street</p>
        <p class="info-line text-gray-600">contact@example.com</p>
        <p class="info-line text-gray-600">(555) 123-4567</p>
      </div>
    </div>
        `,
    },
    {
        name: "Legal Text",
        key: "legal-text",
        media: `
    <div class="legal-section border border-blue-500 p-4" style="zoom: 0.1;">
      <div class="flex gap-4 justify-center">
        <div class="legal-link min-w-24 min-h-6 border border-blue-500"></div>
        <div class="legal-link min-w-24 min-h-6 border border-blue-500"></div>
        <div class="copyright min-w-48 min-h-6 border border-blue-500"></div>
      </div>
    </div>
        `,
        content: `
    <div class="legal-section p-4">
      <div class="flex gap-4 justify-center text-sm text-gray-500">
        <a href="#" class="legal-link hover:text-gray-700">Privacy Policy</a>
        <a href="#" class="legal-link hover:text-gray-700">Terms of Service</a>
        <span class="copyright">© 2024 Your Company</span>
      </div>
    </div>
        `,
    },
    {
        name: "Divider Line",
        key: "divider",
        media: `<div class="divider min-h-px bg-blue-500 my-6" style="zoom: 0.1;"></div>`,
        content: `<div class="divider min-h-px bg-gray-200 my-6"></div>`,
    },
    {
        name: "CTA Section",
        key: "cta-section",
        media: `
    <div class="cta-section border border-blue-500 p-8 text-center" style="zoom: 0.1;">
      <div class="title min-w-64 min-h-8 mx-auto mb-4 border border-blue-500"></div>
      <div class="button min-w-32 min-h-10 mx-auto border border-blue-500"></div>
    </div>
        `,
        content: `
    <div class="cta-section p-8 text-center bg-gray-50">
      <h3 class="title text-2xl font-bold mb-6">Ready to get started?</h3>
      <button class="button px-8 py-3 bg-blue-500 text-white rounded-lg hover:bg-blue-600">
        Contact Us
      </button>
    </div>
        `,
    },
];
